"use client";

import { c as _c } from "react/compiler-runtime";
import type { FC, HTMLProps } from "react";
import { Input as BaseInput } from "./Input.styles";
import type { InputProps } from "./Input.d";
const Input: FC<Omit<HTMLProps<HTMLInputElement>, keyof InputProps> & InputProps> = t0 => {
  const $ = _c(6);
  let error;
  let props;
  if ($[0] !== t0) {
    ({
      error,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = error;
    $[2] = props;
  } else {
    error = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== error || $[4] !== props) {
    t1 = <BaseInput {...props} $error={error} />;
    $[3] = error;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default Input;